import React from "react";
import { IconPathProps } from "../../types";

export const HomeCustomize = ({ lineColor, strokeWidth }: IconPathProps) => (
  <>
    <path
      d="M18.18972 6.431532L16.06848 4.310208 13.86528 5.633916 12.62172 5.11854 12 2.625H9L8.378244 5.118576 7.134732 5.633988 4.931532 4.310256 2.810208 6.43158 4.133964 8.634768 3.618564 9.878256 1.125 10.5V13.5L3.61854 14.12172 4.133916 15.36528 2.810172 17.56848 4.931484 19.68984 7.134672 18.36612 8.37822 18.88152M12.11364 9.470472C11.647692 9.172632 11.094 9 10.5 9 8.843148 9 7.5 10.343148 7.5 12 7.5 12.4746 7.61022 12.92352 7.806444 13.3224 7.924788 13.563 8.074404 13.78548 8.25 13.98432"
      stroke={lineColor}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M15.195 21.375H10.875V13.29336L16.875 9.375 22.875 13.29336V21.375H18.555M15.195 21.375V16.23216H18.555V21.375M15.195 21.375H18.555"
      stroke={lineColor}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </>
);
